import { useToast } from "@chakra-ui/react";
import { formatedDate } from "helpers/formated";
import {
  parsedDayDashboard,
  parsedWeekDashboard,
} from "helpers/parsed/parsedWeekDashboard";
import { IDashboardContext } from "Interfaces/Providers/Dashboard";
import { createContext, ReactNode, useCallback, useState } from "react";
import schedule from "services/schedule";
import { useImmer } from "use-immer";

interface Auth0ProviderProps {
  children: ReactNode;
}

const DashboardProvider = ({ children }: Auth0ProviderProps) => {
  const toast = useToast();
  const [idSelectDate, setSelectIdDate] = useState("");

  const [loading, setLoading] = useState(false);
  const [loadingDrawer, setLoadingDrawer] = useState(false);
  const [isFirstData, setFirstData] = useState(true);

  const [filename, setFilename] = useState("Orçamento Comercial - Relatório");

  const [data, updateData] = useImmer<any[]>([]);
  const [dataDay, updateDataDay] = useImmer<any[]>([]);

  function getFirstDayOfMonth() {
    const now = new Date();
    return formatedDate(String(new Date(now.getFullYear(), now.getMonth(), 1)));
  }

  // Função para obter o último dia do mês
  function getLastDayOfMonth() {
    const now = new Date();
    return formatedDate(
      String(new Date(now.getFullYear(), now.getMonth() + 1, 0))
    );
  }

  const getData = useCallback(
    async (start: any, end: any) => {
      setLoading(true);
      setFirstData(false);
      const valueStore = JSON.parse(localStorage.getItem("storeUser"));

      schedule
        .getScheduleDashboardWeek(valueStore?.value, start, end)
        .then((response) => {
          updateData(response.data?.data);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    },
    [updateData]
  );

  const getDataDay = useCallback(
    async (date: any) => {
      setLoadingDrawer(true);
      setFirstData(false);
      if (date === "NaN-NaN-NaN") {
        return;
      }
      const valueStore = JSON.parse(localStorage.getItem("storeUser"));

      schedule
        .getScheduleDashboardDay(valueStore?.value, date)
        .then((response) => {
          updateDataDay(response.data?.data);
          setLoadingDrawer(false);
        })
        .catch(() => {
          setLoadingDrawer(false);
        });
    },
    [updateDataDay]
  );

  return (
    <DashboardContext.Provider
      value={{
        loading,
        loadingDrawer,
        data: parsedWeekDashboard(data),
        isFirstData,
        idSelectDate,
        dataDay: parsedDayDashboard(dataDay),
        getData,
        setSelectIdDate,
        getDataDay,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export default DashboardProvider;
export const DashboardContext = createContext<IDashboardContext>(
  {} as IDashboardContext
);
